export function convertArrayToObject(array: any[], key: string, value: string) {
  const object: any = {};

  for (const element of array) {
    object[element[key]] = element[value];
  }

  return object;
}
